// extracted by mini-css-extract-plugin
export default {"main":"Loading_main__04G35","loader":"Loading_loader__fEmwQ","rotation":"Loading_rotation__C-qNw"};